import * as actionTypes from './action-types'
import { USER_FETCH_USER } from '@/store/modules/user/action-types'
import { USER_AGENCY_FETCH_INFOS } from '@/store/modules/user/agency/action-types'
import { SERVICE_REFRESH } from '@/store/modules/service/action-types'

export default {
  [actionTypes.REFRESH_DATA]: async ({ state, dispatch, commit }) => {
    if (state.user.authToken === null) return
    await dispatch('user/' + USER_FETCH_USER)
    await dispatch('user/agency/' + USER_AGENCY_FETCH_INFOS)
    if (state.service.active) {
      await dispatch('service/' + SERVICE_REFRESH)
    }
  }
}
